import React, { useEffect, useState } from "react";
import { Grid, MenuItem, Typography, Box, TextField, Chip, Autocomplete } from "@mui/material";
import useStyles from "./style";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { EditOutlined } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";
import _ from "lodash";
import dayjs from "dayjs";

//Api
import servicesApi from "../../../../../Services/Service";
import subcmpnysApi from "../../../../../Services/Subcompany";
import fileUploadApi from "../../../../../Services/ImageUpload";
import driverApi from "../../../../../Services/Driver";
import tripPreferenceApi from "../../../../../Services/TripPreference";


const Services = ({ onRef, formikServices, driverId, setsubmitButton, setSkipButton }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [servicesData, setServicesData] = useState([]);
  const [subcompaniesData, setSubcompaniesData] = useState([]);
  const [allowedTypesName, setAllowedTypeNames] = useState([]);
  const [tripPreferencesOptions, setTripPreferencesOptions] = useState([]);
  const [driverServiceData, setDriverServiceData] = useState([]);

  useEffect(() => {
    setsubmitButton(true);
    setSkipButton(true);
  }, [setsubmitButton, setSkipButton]);

  const getFormData = () => {
    return {
      formikValues: formikServices.values,
    };
  };

  useEffect(() => {
    onRef && onRef(getFormData);
  }, [onRef, formikServices.values]);

  const handleLicenseExpiryDate = (newValue) => {
    if (newValue === null || newValue === "") {
      formikServices.setFieldValue("licenseExpiryDate", newValue);
    } else {
      const formattedDate = dayjs(newValue).format("MM/DD/YYYY HH:mm:ss");
      formikServices.setFieldValue("licenseExpiryDate", formattedDate);
    }
  };

  const handleInsuranceExpiryDate = (newValue) => {
    if (newValue === null || newValue === "") {
      formikServices.setFieldValue("insuranceExpiryDate", null);
    } else {
      const formattedDate = dayjs(newValue).format("MM/DD/YYYY HH:mm:ss");
      formikServices.setFieldValue("insuranceExpiryDate", formattedDate);
    }
  };

  const getAllServices = () => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setServicesData(res?.data?.data?.data || []);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Failed to fetch services",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };
    servicesApi.getServiceswithfaremodel().then(onSuccess, onFailure);
  };

  const getAllSubcompanies = () => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setSubcompaniesData(res?.data?.data || []);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Failed to fetch subcompanies",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };
    subcmpnysApi.getallsubcmpniesnamelist().then(onSuccess, onFailure);
  };


  const getAllTripPreferences = () => {
    tripPreferenceApi.getTripPreferencesList().then(
      (res) => {
        if (res?.data?.status === true) {
          const rawData = res?.data?.data?.data || res?.data?.data || [];
          const options = rawData.map((item) => ({
            label: item.name,
            value: item._id || item.name,
          }));
          setTripPreferencesOptions(options);
        }
      },
      (err) => {
        console.error("Failed to fetch trip preferences", err);
      }
    );
  };


  useEffect(() => {
    getAllServices();
    getAllSubcompanies();
    getAllTripPreferences();

  }, []);

  useEffect(() => {
    if (servicesData?.length) {
      const typeOptions = servicesData.map((service) => ({
        label: service.serviceName,
        value: service._id,
      }));
      setAllowedTypeNames(typeOptions);
    }
  }, [servicesData]);

  const handleAllowTypes = (_, values) => {
    const selectedIds = values.map((option) => option.value);
    formikServices.setFieldValue("allowedTypes", selectedIds);
  };

 
  const handleTripPreferences = (_, values) => {
    const selectedVals = values.map((option) => option.value);
    formikServices.setFieldValue("tripPreferences", selectedVals);
  };

  const selectedServiceObj = servicesData.find((s) => s._id === formikServices.values.service);
  const isPremiumFare = Boolean(selectedServiceObj?.Premiumfare);

  const driverServiceDetailsGet = () => {
    if (!driverId) return;
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDriverServiceData(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Failed to fetch driver's service details",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };
    driverApi.getDriverServiceDetails(driverId).then(onSuccess, onFailure);
  };

  useEffect(() => {
    driverServiceDetailsGet();
  }, [driverId]);

  useEffect(() => {
    if (!_.isEmpty(driverServiceData)) {
      formikServices.setFieldValue("service", driverServiceData?.serviceTypeId || "");
      formikServices.setFieldValue("serviceType", driverServiceData?.serviceKind || "");
      formikServices.setFieldValue("subcompanyname", driverServiceData?.sub_companyName || "");
      formikServices.setFieldValue("vehicleNumber", driverServiceData?.vehicleNumber || "");
      formikServices.setFieldValue("vehicleModel", driverServiceData?.vehicleModel || "");
      formikServices.setFieldValue("driverLicenseNumber", driverServiceData?.driverLicenseNumber || "");
      formikServices.setFieldValue("licenseExpiryDate", driverServiceData?.licenseExpiryDate || "");
      formikServices.setFieldValue("vehicleInsuranceNumber", driverServiceData?.vehicleInsuranceNumber || "");
      formikServices.setFieldValue("insuranceExpiryDate", driverServiceData?.insuranceExpiryDate || "");
      formikServices.setFieldValue("allowedTypes", driverServiceData?.allowedTypes || []);
      formikServices.setFieldValue("tripPreferences", driverServiceData?.tripPreferences || []);
      formikServices.setFieldValue("vehicleColour", driverServiceData?.vehicleColour || "");
      formikServices.setFieldValue("vehicleimage", driverServiceData?.vehicleimage || "");
    }
  }, [driverServiceData]);

  const uploadProfileImage = (acceptedFiles) => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Vehicle image uploaded successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
        formikServices.setFieldValue("vehicleimage", res?.data?.data?.vehicleimage);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.data?.msg || "Error while uploading image",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };
    const formData = new FormData();
    acceptedFiles.forEach((file) => {
      formData.append("image", file);
    });
    formData.append("userId", driverId);

    fileUploadApi.carimageupload(formData).then(onSuccess, onFailure);
  };

  const maxFileSize = 5242880;
  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert("File size is larger than 5MB");
      return { code: "file-too-large", message: "File too large" };
    }
    return null;
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: maxFileSize,
    maxFiles: 1,
    accept: "image/*",
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles[0]?.size < maxFileSize) {
        uploadProfileImage(acceptedFiles);
      }
    },
  });

  return (
    <Box className={classes.BasicInformationStyles}>
      {/* Left Column – Vehicle Photo */}
      <Box className={classes.leftColumn}>
        <Box className={classes.avatarWrapper}>
          <img
            src={formikServices.values.vehicleimage || "/assets/images/logos/no-image.png"}
            alt="Vehicle"
            className={classes.avatarImg}
          />
          <Box component="span" className={classes.editIconOverlay} {...getRootProps()} onClick={open}>
            <input {...getInputProps()} />
            <EditOutlined />
          </Box>
        </Box>
        <Typography className={classes.photoLabel}>Vehicle Image</Typography>
        <Typography className={classes.photoSubLabel}>JPG, PNG up to 5MB</Typography>
      </Box>

      {/* Right Column – Form */}
      <Box className={classes.rightColumn}>
        <Grid container spacing={2}>
          {/* Service */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Service</Typography>
            <TextField
              name="service"
              id="service"
              select
              value={formikServices.values.service || ""}
              onChange={formikServices.handleChange}
              error={formikServices.touched.service && Boolean(formikServices.errors.service)}
              helperText={formikServices.touched.service && formikServices.errors.service}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            >
              {servicesData.map((s) => (
                <MenuItem key={s._id} value={s._id}>
                  {s.serviceName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* Service Type */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Service Type</Typography>
            <TextField
              name="serviceType"
              id="serviceType"
              select
              value={formikServices.values.serviceType || ""}
              onChange={formikServices.handleChange}
              error={formikServices.touched.serviceType && Boolean(formikServices.errors.serviceType)}
              helperText={formikServices.touched.serviceType && formikServices.errors.serviceType}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            >
              <MenuItem value="OWN_SERVICE">Own Service</MenuItem>
              <MenuItem value="ATTACHED_SERVICE">Attached Service</MenuItem>
            </TextField>
          </Grid>

          {/* Sub-company */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Sub-company</Typography>
            <TextField
              name="subcompanyname"
              id="subcompanyname"
              select
              value={formikServices.values.subcompanyname || ""}
              onChange={formikServices.handleChange}
              error={formikServices.touched.subcompanyname && Boolean(formikServices.errors.subcompanyname)}
              helperText={formikServices.touched.subcompanyname && formikServices.errors.subcompanyname}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
              disabled={formikServices.values.serviceType !== "ATTACHED_SERVICE"}
            >
              {subcompaniesData.map((c) => (
                <MenuItem key={c._id} value={c.companyName}>
                  {c.companyName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* Allowed Types (Multi Select Autocomplete) */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Allowed Types</Typography>
            <Autocomplete
              multiple
              id="allowedTypes"
              name="allowedTypes"
              options={allowedTypesName}
              getOptionLabel={(option) => option.label}
              value={allowedTypesName.filter((option) => formikServices.values.allowedTypes?.includes(option.value)) || []}
              onChange={handleAllowTypes}
              className={classes.autocompleteInput}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={formikServices.values.allowedTypes?.length > 0 ? "" : "Select allowed services"}
                  variant="outlined"
                  size="small"
                  error={formikServices.touched.allowedTypes && Boolean(formikServices.errors.allowedTypes)}
                  helperText={formikServices.touched.allowedTypes && formikServices.errors.allowedTypes}
                />
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => <Chip key={index} label={option.label} size="small" {...getTagProps({ index })} />)
              }
            />
          </Grid>


   
          {/* Trip Preferences (Multi Select Autocomplete - Shown when Premiumfare is true) */}
          {isPremiumFare && (
            <Grid item xs={12} md={6}>
              <Typography className={classes.formLabel}>Trip Preferences</Typography>
              <Autocomplete
                multiple
                id="tripPreferences"
                name="tripPreferences"
                options={tripPreferencesOptions}
                getOptionLabel={(option) => option.label || ""}
                value={
                  tripPreferencesOptions.filter((option) =>
                    formikServices.values.tripPreferences?.includes(option.value)
                  ) || []
                }
                onChange={handleTripPreferences}
                className={classes.autocompleteInput}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={
                      formikServices.values.tripPreferences?.length > 0 ? "" : "Select trip preferences"
                    }
                    variant="outlined"
                    size="small"
                    error={
                      formikServices.touched.tripPreferences &&
                      Boolean(formikServices.errors.tripPreferences)
                    }
                    helperText={
                      formikServices.touched.tripPreferences &&
                      formikServices.errors.tripPreferences
                    }
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip key={index} label={option.label} size="small" {...getTagProps({ index })} />
                  ))
                }
              />
            </Grid>
          )}


          {/* Vehicle Number */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Vehicle Number</Typography>
            <TextField
              name="vehicleNumber"
              id="vehicleNumber"
              placeholder="Enter Vehicle Number"
              value={formikServices.values.vehicleNumber}
              onChange={formikServices.handleChange}
              error={formikServices.touched.vehicleNumber && Boolean(formikServices.errors.vehicleNumber)}
              helperText={formikServices.touched.vehicleNumber && formikServices.errors.vehicleNumber}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            />
          </Grid>

          {/* Vehicle Model */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Vehicle Model</Typography>
            <TextField
              name="vehicleModel"
              id="vehicleModel"
              placeholder="Enter Vehicle Model"
              value={formikServices.values.vehicleModel}
              onChange={formikServices.handleChange}
              error={formikServices.touched.vehicleModel && Boolean(formikServices.errors.vehicleModel)}
              helperText={formikServices.touched.vehicleModel && formikServices.errors.vehicleModel}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            />
          </Grid>

          {/* Vehicle Colour */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Vehicle Colour</Typography>
            <TextField
              name="vehicleColour"
              id="vehicleColour"
              placeholder="Enter Vehicle Colour"
              value={formikServices.values.vehicleColour}
              onChange={formikServices.handleChange}
              error={formikServices.touched.vehicleColour && Boolean(formikServices.errors.vehicleColour)}
              helperText={formikServices.touched.vehicleColour && formikServices.errors.vehicleColour}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            />
          </Grid>

          {/* Driver License Number */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Driver License Number</Typography>
            <TextField
              name="driverLicenseNumber"
              id="driverLicenseNumber"
              placeholder="Enter License Number"
              value={formikServices.values.driverLicenseNumber}
              onChange={formikServices.handleChange}
              error={formikServices.touched.driverLicenseNumber && Boolean(formikServices.errors.driverLicenseNumber)}
              helperText={formikServices.touched.driverLicenseNumber && formikServices.errors.driverLicenseNumber}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            />
          </Grid>

          {/* License Expiry Date */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>License Expiry Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={formikServices.values.licenseExpiryDate ? dayjs(formikServices.values.licenseExpiryDate) : null}
                onChange={handleLicenseExpiryDate}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={formikServices.touched.licenseExpiryDate && Boolean(formikServices.errors.licenseExpiryDate)}
                    helperText={formikServices.touched.licenseExpiryDate && formikServices.errors.licenseExpiryDate}
                    fullWidth
                    size="small"
                    variant="outlined"
                    className={classes.formInput}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          {/* Vehicle Insurance Number */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Vehicle Insurance Number</Typography>
            <TextField
              name="vehicleInsuranceNumber"
              id="vehicleInsuranceNumber"
              placeholder="Enter Insurance Number"
              value={formikServices.values.vehicleInsuranceNumber}
              onChange={formikServices.handleChange}
              error={formikServices.touched.vehicleInsuranceNumber && Boolean(formikServices.errors.vehicleInsuranceNumber)}
              helperText={formikServices.touched.vehicleInsuranceNumber && formikServices.errors.vehicleInsuranceNumber}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.formInput}
            />
          </Grid>

          {/* Insurance Expiry Date */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.formLabel}>Insurance Expiry Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={formikServices.values.insuranceExpiryDate ? dayjs(formikServices.values.insuranceExpiryDate) : null}
                onChange={handleInsuranceExpiryDate}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={formikServices.touched.insuranceExpiryDate && Boolean(formikServices.errors.insuranceExpiryDate)}
                    helperText={formikServices.touched.insuranceExpiryDate && formikServices.errors.insuranceExpiryDate}
                    fullWidth
                    size="small"
                    variant="outlined"
                    className={classes.formInput}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Services;
